import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Estado vacío de listados y tablas.
 *
 * Reemplaza al bloque suelto que estaba repetido en 65 pantallas:
 *
 *   <div class="no-data-table">
 *     <span class="with-icon"><mat-icon>search_off</mat-icon>No se encontraron
 *     datos para mostrar.</span>
 *   </div>
 *
 * Además de unificar el aspecto, deja lugar para decir POR QUÉ está vacío y qué
 * puede hacer el usuario: "no hay resultados con esos filtros" no es lo mismo
 * que "todavía no cargaste nada", y el mensaje genérico no distinguía.
 *
 * Uso mínimo:   <app-sin-datos *ngIf="dataSource.data.length == 0"></app-sin-datos>
 * Con contexto: <app-sin-datos mensaje="No hay liquidaciones en el período"
 *                              detalle="Probá ampliando el rango de fechas."
 *                              icono="event_busy"
 *                              textoAccion="Limpiar filtros"
 *                              (accion)="limpiar()"></app-sin-datos>
 */
@Component({
  selector: 'app-sin-datos',
  templateUrl: './sin-datos.component.html',
  styleUrls: ['./sin-datos.component.css']
})
export class SinDatosComponent {

  /** Título. El default sirve para el caso genérico de una tabla vacía. */
  @Input() mensaje: string = "No se encontraron datos";

  /** Segunda línea, opcional. Sirve para sugerir qué hacer. */
  @Input() detalle: string = "";

  /** Icono de Material. search_off para búsquedas sin resultados. */
  @Input() icono: string = "search_off";

  /** Si se completa, aparece un botón. Sin esto no se muestra ninguno. */
  @Input() textoAccion: string = "";

  @Input() iconoAccion: string = "refresh";

  /**
   * Compacto para tablas chicas y diálogos, donde el estado vacío no debe dominar.
   *
   * Acepta las dos formas: [compacto]="true" y compacto="true". Sin el setter,
   * la segunda pasa el STRING "true" y el compilador de plantillas la rechaza,
   * que es un error fácil de cometer y molesto de diagnosticar.
   */
  @Input()
  set compacto(valor: boolean | string) {
    this._compacto = valor === true || valor === 'true' || valor === '';
  }
  get compacto(): boolean { return this._compacto; }
  private _compacto = false;

  @Output() accion = new EventEmitter<void>();

  onAccion() {
    this.accion.emit();
  }
}
